function duration(rawDuration) {
  if (!rawDuration) {
    return '-';
  }

  let minutes = parseInt(rawDuration / 60, 10);
  minutes = minutes > 9 ? minutes : `0${minutes}`;
  let seconds = rawDuration % 60;
  seconds = seconds > 9 ? seconds : `0${seconds}`;

  return `${minutes}:${seconds}`;
}

export default duration;



// WEBPACK FOOTER //
// ./src/filters/duration.js